import { getAttributesCamelCase } from "./getAttributesCamelCase";
import { JSDOM } from "jsdom";

describe("getAttributes", () => {
    it("returns the attributes", () => {
        const dom = new JSDOM();
        const div = dom.window.document.createElement("div");
        expect(getAttributesCamelCase(div)).toMatchObject({});
        div.setAttribute("test", "content");
        div.setAttribute("foo", "content2");
        expect(getAttributesCamelCase(div)).toMatchObject({
            test: "content",
            foo: "content2"
        });
    });

    it("returns the attributes with the correct casing", () => {
        const dom = new JSDOM();
        const div = dom.window.document.createElement("div");
        expect(getAttributesCamelCase(div)).toMatchObject({});
        div.setAttribute("test", "content");
        div.setAttribute("foo", "content2");
        div.setAttribute("foo-baz-bar", "content3");
        expect(getAttributesCamelCase(div)).toMatchObject({
            test: "content",
            foo: "content2",
            fooBazBar: "content3"
        });
    });

    it("handles undefined elements", () => {
        expect(getAttributesCamelCase(undefined)).toMatchObject({});
    });
});
